import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
/** Service permettant de stocker dans l'appli des données liées à l'utilisateur comme le site de connexion */
@Injectable({
  providedIn: "root",
})
export class UserContextService {
  private _siteConnexion = undefined;
  set siteConnexion(siteConnexion: string) {
    this._siteConnexion = siteConnexion;
    // Propagation. par exemple pour mettre à jour le layout. Le siteConnexion est setté lors du login
    this.siteConnexionSubject.next(this._siteConnexion);
  }
  get siteConnexion(): string {
    this._siteConnexion = this._siteConnexion
      ? this._siteConnexion
      : JSON.parse(localStorage.plancUser)?.SiteConnexion;
    // Propagation. par exemple pour mettre à jour le layout. Le siteConnexion est getté lors d'un refresh. Dans ce cas on n'a que le localStorage pour le récupérer
    this.siteConnexionSubject.next(this._siteConnexion);
    return this._siteConnexion;
  }
  /** Base de connexion */
  private _baseConnexion = undefined;
  set baseConnexion(baseConnexion: string) {
    this._baseConnexion = baseConnexion;
    // Propagation. par exemple pour mettre à jour le layout. Le baseConnexion est setté lors du login
    this.baseConnexionSubject.next(this._baseConnexion);
  }
  get baseConnexion(): string {
    this._baseConnexion = this._baseConnexion
      ? this._baseConnexion
      : JSON.parse(localStorage.plancUser)?.BaseConnexion;
    // Propagation. par exemple pour mettre à jour le layout. Le baseConnexion est getté lors d'un refresh. Dans ce cas on n'a que le localStorage pour le récupérer
    this.baseConnexionSubject.next(this._baseConnexion);
    return this._baseConnexion;
  }
  /** Profil utilisateur */
  private _profil = undefined;
  set profil(profil: string) {
    this._profil = profil;
  }
  get profil(): string {
    this._profil = this._profil
      ? this._profil
      : JSON.parse(localStorage.plancUser)?.Profil;
    return this._profil;
  }
    /** utilisateur */
    private _userConnected = undefined;
    set userConnected(userConnected: string) {
      this._userConnected = userConnected;
      this.userConnectedSubject.next(this._userConnected);
    }
    get userConnected(): string {
      this._userConnected = this._userConnected
        ? this._userConnected
        : localStorage?.plancUser ?
        JSON.parse(localStorage.plancUser)?.Gestionnaire : null;
        this.userConnectedSubject.next(this._userConnected);
      return this._userConnected;
    }
  public siteConnexionSubject = new BehaviorSubject<string>(null);
  public baseConnexionSubject = new BehaviorSubject<string>(null);
  public userConnectedSubject = new BehaviorSubject<string>(null);
  constructor() {}
}
